import React, { useEffect, useState } from "react";
import { Button } from "../Button";
import { HeroWrapper, HeroBadge, HeroTitle, HeroCtas, HeroCTA, HeroSubtitle, HeroContent, HeroImage } from "./Hero";
import { TestimonialCarouselWrapper, TestimonialContent, TestimonialImage, TestimonialLogo, TestimonialQuote, TestimonialWrapper, TestimonyCompany, TestimonyName, TestimonyPosition } from "./Testimonial";
import Head from "next/head";
import { Icon } from "../Icon";
import Carousel from "nuka-carousel";
import { buildOgImage } from "../helpers";
import ParallaxHero from "../ParallaxHero";
import { GoldRushCode, GoldRushColorList, GoldRushComponentCustomLeft, GoldRushComponentCustomRight, GoldRushComponentImage, GoldRushComponentSwitch, GoldRushComponentSwitchLeft, GoldRushComponentSwitchRight, GoldRushCustomContent, GoldRushDescription, GoldRushHeroCode, GoldRushSectionTitle, GoldRushSubtitle, GoldRushTabContent, GoldRushTitle } from "./GoldRushComponents";
import { HugeCTAWrapper, HugeCTATitle, HugeCTASubtitle, HugeCTACtas, HugeCTACTA } from "./HugeCTA";
import { Tabs } from "../Tabs";
import { useSearchParams } from 'next/navigation';
import { useRouter } from "next/router";
import { GRK_BALANCE_SKELETON_DARK_DESKTOP, GRK_BALANCE_SKELETON_DARK_MOBILE, GRK_BALANCE_SKELETON_LIGHT_DESKTOP, GRK_BALANCE_SKELETON_LIGHT_MOBILE } from "../helpers/GoldRushSkeletons";
import { Switch } from "../Switch";
import { GradientDivider, GradientDividerLeft } from "../GradientDivider";

const testimonialsData = require("../../data/dato-testimonials.json");

export const GoldRushPage = ({ content, grkData }) => {
    const getSection = (slug) => {
        return content.content.filter((section) => section.section === slug)[0];
    };
    const hero = getSection("hero");
    const testimonials = testimonialsData.data.allTestimonial2s;
    const ogImage = buildOgImage(content.meta.title, content.category, hero.image.src.replace("https://www.datocms-assets.com/", ""));
    const title = `${content.meta.title}` + (content.category.length > 0 ? ` | ${content.category}` : "") + ` | Covalent`;
    const [showCode, setShowCode] = useState(true);
    const searchParams = useSearchParams();
    const search = searchParams.get('component');
    const router = useRouter();
    const [color, setColor] = useState("#ec4899");
    const [dark, setDark] = useState(false);
    const indexComponentCarousel = grkData.findIndex(obj => obj.component === search);
    const [firstLand, setLand] = useState(false);

    const updateComponentQueryParam = (newComponent) => {
        router.replace({
            pathname: '/products/goldrush',
            query: { component: newComponent },
        }, 
        undefined, { shallow: true, scroll: false});
        
    };

    useEffect(() => {
        const scrollToElement = (elementId) => {
            const element = document.getElementById(elementId);
    
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                });
            }
        };
    
        if(firstLand){
            scrollToElement("components");
        }
        setLand(true);

    }, [search]); 

    return <>
        <Head>
            <title>{title}</title>
            <meta name="description" content={content.meta.description} />
            <meta name="keywords" content={content.meta.keywords} />
            <meta property="og:description" content={content.meta.description} />
            <meta property="og:title" content={title} />
            <meta name="og:image" content={ogImage} />
        </Head>
        <div className="landing-page">
            <div className="github-banner">
                <a className="git-button" href="https://github.com/covalenthq/goldrush-kit">
                    <Icon icon={"github"} size="2" />  
                    Fork on Github
                </a>
            </div>
            <ParallaxHero imageUrl="https://www.datocms-assets.com/86369/1700775331-particles-6.jpg?dpr=0.25&fm=webp 960w,https://www.datocms-assets.com/86369/1700775331-particles-6.jpg?dpr=0.5&fm=webp 1920w,https://www.datocms-assets.com/86369/1700775331-particles-6.jpg?dpr=0.75&fm=webp 2880w,https://www.datocms-assets.com/86369/1700775331-particles-6.jpg?fm=webp 3840w">
                <HeroWrapper size="lg" dark>
                    <GradientDivider/>
                    <GradientDividerLeft/>
                    <HeroContent>
                        <HeroBadge>
                            {content.category}
                            <div className="flex-center">
                                <Icon icon="chevron-right" size="0.7" />
                            </div>
                            {content.badge}
                        </HeroBadge>
                        <HeroTitle>
                            {hero.title}
                        </HeroTitle>
                        <HeroSubtitle>
                            {hero.subtitle}
                        </HeroSubtitle>
                        <GoldRushHeroCode code={"@covalenthq/goldrush-kit"} />
                        <HeroCtas>
                            <HeroCTA><Button href="/docs/unified-api/goldrush/kit/gold-rush-provider/">Get started <Icon color={"#fff"} icon="chevron-right" size="0.7" /></Button></HeroCTA>
                            <HeroCTA><Button secondary={"true"} href="https://github.com/covalenthq/goldrush-kit"> 
                                <Icon icon={"github"} size="1" />  
                                GitHub
                            </Button>
                            </HeroCTA>
                        </HeroCtas>
                    </HeroContent>
                    <HeroImage image={hero.image} />
                </HeroWrapper>
                {/* switch component */}
                <div className="goldrush_desktop" id="components">
                    <GoldRushComponentSwitch>
                        <GoldRushSectionTitle>GoldRush UI Components</GoldRushSectionTitle>
                        <p>A complete set of React components to jumpstart your dApp journey.</p>

                        <Tabs activeTab={search} onValueChange={(e)=>{
                            updateComponentQueryParam(e);
                        }}>
                            {grkData.map((o, i) => {
                                const component = `<${o.component} />`;

                                const sample = `import { ${o.component} } from "@covalenthq/goldrush-kit";\n
export default function CovalentDemo() {
    return ${component};
}`;
                                return <GoldRushTabContent data-label={o.component} key={i}>
                                    <GoldRushComponentSwitchLeft>
                                        <GoldRushTitle>{o.title}</GoldRushTitle>
                                        <GoldRushSubtitle>{o.subtitle}</GoldRushSubtitle>
                                        <GoldRushDescription>{o.description}</GoldRushDescription>
                                        <HeroCtas>
                                            {/* <HeroCTA><Button href="/platform/auth/register/">Start Building <Icon color={"#fff"} icon="chevron-right" size="0.7" /></Button></HeroCTA> */}
                                            <HeroCTA><Button secondary={"true"} href={`/docs/unified-api/goldrush/kit/${o.slug}/`}>Read Documentation</Button></HeroCTA>
                                        </HeroCtas>
                                    </GoldRushComponentSwitchLeft>
                                    <GoldRushComponentSwitchRight>
                                        <div className="grk-image">
                                            <GoldRushComponentImage src={o.image.responsiveImage} />
                                            <div className="gold-rush-code">
                                                <GoldRushCode code={[
                                                    {
                                                        title: "React",
                                                        code: sample
                                                    },  
                                                ]} />
                                            </div>
                                            <div className="show-code">
                                                <Button onClick={() => { setShowCode(!showCode); }}>{showCode ? "Hide code" : "Show code"}</Button>
                                            </div>
                                        </div>
                                    </GoldRushComponentSwitchRight>
                                </GoldRushTabContent>;
                            })}
                        </Tabs>
                    </GoldRushComponentSwitch>
                </div>
                <div className="goldrush_mobile">
                    <GoldRushComponentSwitch>
                        <GoldRushSectionTitle>GoldRush UI Components</GoldRushSectionTitle>
                        <p>A complete set of React components to jumpstart your dApp journey.</p>
                        <Carousel slideIndex={indexComponentCarousel < 0 ? 0 : indexComponentCarousel}>
                            {grkData.map((o, i) => {
                                return <GoldRushTabContent data-label={o.component} key={i}>
                                    <GoldRushComponentSwitchLeft>
                                        <GoldRushTitle>{o.title}</GoldRushTitle>
                                        <GoldRushSubtitle>{o.subtitle}</GoldRushSubtitle>
                                        <GoldRushDescription>{o.description}</GoldRushDescription>
                                        <HeroCtas>
                                            <HeroCTA><Button secondary={"true"} href={`/docs/unified-api/goldrush/kit/${o.slug}/`}>Read Documentation</Button></HeroCTA>
                                        </HeroCtas>
                                    </GoldRushComponentSwitchLeft>
                                    <GoldRushComponentSwitchRight>
                                        <div className="grk-image">
                                            <GoldRushComponentImage src={o.image.responsiveImage} />
                                            {/* <div className="gold-rush-code">
                                                    <GoldRushCode code={sample}/>
                                                </div>
                                                <div className="show-code">
                                                    <Button onClick={()=>{setShowCode(!showCode);}}>{showCode ? "Hide code" : "Show code"}</Button>
                                                </div> */}
                                        </div>
                                    </GoldRushComponentSwitchRight>
                                </GoldRushTabContent>;
                            })}
                        </Carousel>
                    </GoldRushComponentSwitch>
                </div>
                <GoldRushComponentSwitch>
                    {/* <GoldRushSectionTitle>Customize your components</GoldRushSectionTitle> */}
                    <GoldRushCustomContent>
                        <GoldRushComponentCustomRight>
                            <div className="grk-image-svg">
                                {dark ? GRK_BALANCE_SKELETON_DARK_DESKTOP : GRK_BALANCE_SKELETON_LIGHT_DESKTOP}
                                <div className="grk-mobile-skeleton">
                                    {dark ? GRK_BALANCE_SKELETON_DARK_MOBILE : GRK_BALANCE_SKELETON_LIGHT_MOBILE}
                                </div>
                            </div>
                        </GoldRushComponentCustomRight>
                        <GoldRushComponentCustomLeft>
                            <GoldRushTitle>Customize your Components</GoldRushTitle>

                            <div className="flex grk-controls">
                                <Switch active={dark} setActive={setDark} left={"Light"} right={"Dark"}/>
                            </div>
                            <GoldRushColorList setColor={setColor}/>
                            <HeroCtas>
                                <HeroCTA><Button secondary={"true"} href={`/docs/unified-api/goldrush/kit/token-balances-list-view/`}>Read Documentation</Button></HeroCTA>
                            </HeroCtas>
                        </GoldRushComponentCustomLeft>
                    </GoldRushCustomContent>
                </GoldRushComponentSwitch>
                {/* <div className="goldrush_desktop">
                    <GoldRushComponentSwitch>
                        <Tabs activeTab="Desktop">
                            {displayComponents.list.map((o, i) => {
                                return <GoldRushTabContent data-label={o.title} key={i}>
                                    <GoldRushComponentSwitchRight>
                                        <div className="grk-image">
                                            <GoldRushComponentImage src={o.image} />
                                        </div>
                                    </GoldRushComponentSwitchRight>
                                    <GoldRushComponentSwitchLeft>
                                        <GoldRushTitle>{o.title}</GoldRushTitle>
                                        <GoldRushSubtitle>{o.description}</GoldRushSubtitle>
                                        <HeroCtas>
                                            <HeroCTA><Button secondary={"true"} href={`/docs/unified-api/goldrush/kit/token-balances-list-view/`}>Read Documentation</Button></HeroCTA>
                                        </HeroCtas>
                                    </GoldRushComponentSwitchLeft>

                                </GoldRushTabContent>;
                            })}
                        </Tabs>
                    </GoldRushComponentSwitch>
                </div>
                <div className="goldrush_mobile">
                    <TestimonialWrapper>
                        {
                            <Carousel>
                                {displayComponents.list.map((o, i) => {
                                    return <GoldRushTabContent data-label={o.title} key={i}>
                                        <GoldRushComponentSwitchLeft>
                                            <GoldRushTitle>{o.title}</GoldRushTitle>
                                            <GoldRushSubtitle>{o.description}</GoldRushSubtitle>
                                            <HeroCtas>
                                                <HeroCTA><Button secondary={"true"} href={`/docs/unified-api/goldrush/kit/token-balances-list-view/`}>Read Documentation</Button></HeroCTA>
                                            </HeroCtas>
                                        </GoldRushComponentSwitchLeft>
                                        <GoldRushComponentSwitchRight>
                                            <div className="grk-image">
                                                <GoldRushComponentImage src={o.image} />
                                            </div>
                                        </GoldRushComponentSwitchRight>
                                    </GoldRushTabContent>;
                                })}
                            </Carousel>
                        }
                    </TestimonialWrapper>
                </div>
                <div className="goldrush_desktop">
                    <GoldRushComponentSwitch>
                        <Tabs activeTab="Light">
                            {themeComponents.list.map((o, i) => {
                                return <GoldRushTabContent data-label={o.title} key={i}>
                                    <GoldRushComponentSwitchLeft>
                                        <GoldRushTitle>{o.title}</GoldRushTitle>
                                        <GoldRushSubtitle>{o.description}</GoldRushSubtitle>
                                        <HeroCtas>
                                            <HeroCTA><Button href="/platform/auth/register/">Start Building <Icon color={"#fff"} icon="chevron-right" size="0.7" /></Button></HeroCTA>
                                            <HeroCTA><Button secondary={"true"} href={`/docs/unified-api/goldrush/token-balances-list-view/`}>Read Documentation</Button></HeroCTA>
                                        </HeroCtas>
                                    </GoldRushComponentSwitchLeft>
                                    <GoldRushComponentSwitchRight>
                                        <div className="grk-image">
                                            <GoldRushComponentImage src={o.image} />
                                        </div>
                                    </GoldRushComponentSwitchRight>

                                </GoldRushTabContent>;
                            })}
                        </Tabs>
                    </GoldRushComponentSwitch>
                </div>
                <div className="goldrush_mobile">
                    <TestimonialWrapper>
                        {
                            <Carousel>
                                {themeComponents.list.map((o, i) => {
                                    return <GoldRushTabContent data-label={o.title} key={i}>
                                        <GoldRushComponentSwitchLeft>
                                            <GoldRushTitle>{o.title}</GoldRushTitle>
                                            <GoldRushSubtitle>{o.description}</GoldRushSubtitle>
                                            <HeroCtas>
                                                <HeroCTA><Button href="/platform/auth/register/">Start Building <Icon color={"#fff"} icon="chevron-right" size="0.7" /></Button></HeroCTA>
                                                <HeroCTA><Button secondary={"true"} href={`/docs/unified-api/goldrush/token-balances-list-view/`}>Read Documentation</Button></HeroCTA>
                                            </HeroCtas>
                                        </GoldRushComponentSwitchLeft>
                                        <GoldRushComponentSwitchRight>
                                            <div className="grk-image">
                                                <GoldRushComponentImage src={o.image} />
                                            </div>
                                        </GoldRushComponentSwitchRight>

                                    </GoldRushTabContent>;
                                })}
                            </Carousel>
                        }
                    </TestimonialWrapper>
                </div> */}
                <TestimonialWrapper dark>
                    {
                        <Carousel>
                            {testimonials.filter(o => o.product === "api").map((o, i) => {
                                return <TestimonialCarouselWrapper key={i}>
                                    <div className="relative">
                                        <TestimonialImage img={o.faceProfile.responsiveImage} />
                                        <TestimonialLogo img={o.organization.imgwhite.responsiveImage} />
                                    </div>
                                    <TestimonialContent>
                                        <TestimonialQuote>{o.quote}</TestimonialQuote>
                                        <div className="flex place-items-center">
                                            <div>
                                                <TestimonyName>{o.name}</TestimonyName>
                                                <TestimonyPosition>{o.title}</TestimonyPosition>
                                                <TestimonyCompany>{o.organization.name}</TestimonyCompany>
                                            </div>
                                        </div>
                                    </TestimonialContent>
                                </TestimonialCarouselWrapper>;
                            })}
                        </Carousel>
                    }
                </TestimonialWrapper>
                <HugeCTAWrapper dark>
                    <HugeCTATitle>
                        Get started with {content.meta.title}
                    </HugeCTATitle>
                    <HugeCTASubtitle>
                        {content.meta.description}
                    </HugeCTASubtitle>
                    <HugeCTACtas>
                        <HugeCTACTA key="signup"><Button href="/platform/auth/register/">Signup for a free API key <Icon icon="chevron-right" size="0.7" color={"#fff"} /></Button></HugeCTACTA>
                        <HugeCTACTA key="demo"><Button secondary={"true"} href="email:support@covalenthq.com">Speak to an expert</Button></HugeCTACTA>
                    </HugeCTACtas>
                </HugeCTAWrapper>

            </ParallaxHero>
            <style jsx>{`
        .github-banner{
            position:fixed;
            height:100vh;
            display:flex;
            align-items:center;
            right:0;
            // top: var(--main-nav-height);
            z-index:40;
        }
        .git-button{
            display:flex;
            flex-direction:column;
            gap:8px;
            padding:0.5rem;
            color:white;
            width:75px;
            border-radius: 10px 0px 0px 10px;
            text-decoration: none;
            line-height:20px;
            cursor:pointer;
            background: linear-gradient(100deg, rgba(0,216,213,1) 0%, rgba(59,184,196,1) 0%, rgba(179,118,161,1) 100%, rgba(255,76,139,1) 100%);
            transition: box-shadow 0.3s ease-in-out; /* Add a smooth transition for the effect */

        }

        
        .git-button:hover {
            -webkit-box-shadow:0px 0px 31px 0px rgba(230,113,216,0.95);
            -moz-box-shadow: 0px 0px 31px 0px rgba(230,113,216,0.95);
            box-shadow: 0px 0px 31px 0px rgba(230,113,216,0.95);
        }

        .gradient-text {
            background: linear-gradient(90deg, var(--pink), var(--teal));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        .grk-image{
            position:relative;
            margin-top:2rem;
        }
        .grk-image-svg{
            color:${color};
            background:${dark ? "#000426" : "white"};
            padding-bottom:1rem;
            border-radius:var(--border-radius);
            box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
        }
        .grk-mobile-skeleton{
            position:absolute;
            width:15rem;
            bottom:-50px;
            right: -30px;
            padding:0.2rem;
            background:${dark ? "#000426" : "white"};
            border-radius:var(--border-radius);
            box-shadow: ${dark ? "0 25px 50px -12px rgba(255, 255, 255, 0.25)" : "0 25px 50px -12px rgb(0 0 0 / 0.25)"};

        }
        .grk-controls{
            display:flex;
            gap:1rem;
        }
        .show-code{
            position:absolute;
            bottom:10px;
            left: 10px;
            z-index:10;
        }
        .gold-rush-code{
            opacity:${!showCode ? "0" : "100%"};
            transition-property: all;
            transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
            transition-duration: 150ms;
            z-index:60;
        }
        .landing-page{
            overflow:hidden;
        }
        .guide__card {
            background: white;
            border-radius: var(--border-radius);
            overflow: hidden;
            -webkit-transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
            transition: all 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
        }
        .guide__card:hover {
            box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
        }
        .icon-parent{
            color: inherit;
        }
 
        .relative {
            position: relative;
            place-self: center;
        }
        :global(.testimonial .slider-container) {
            width: 100%;
        }
        .place-items-center {
            place-items: center;
        }
        .number-side {
            display: flex;
            flex-direction: column;
            gap: calc(var(--landing-page-gap) * 2);
            width: 50%;
        }
        .video-bg{
            display:block;
        }
        .goldrush_mobile{
            display:none;
        }
        @media (max-width: 1040px) {
            .goldrush_mobile {
                display:block;
            }
            .goldrush_desktop {
                display:none;
            }
            .relative {
                place-self: start;
                display: flex;
                gap: 2rem;
            }
        }


        @media (max-width: 768px) {
            .video-bg{
                display:none;
            }
            .static-bg{
                display:block;
            }
            .grk-mobile-skeleton{
                width:10rem;
                display:none;
            }
        }
        @media (max-width: 768px) {
            .number-side {
                width: 100%;
                gap: 1rem;
            }
        }
    `}</style>
        </div >
    </>;
};
